import { TextField, Box } from "@mui/material";
import React from "react";

import QuestionFooter from "../../../components/QuestionFooter";
import QuestionSubTitle from "../../../components/QuestionSubTitle";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function TextAnswer({
  name,
  label,
  subTitle,
  footer,
  value = "",
  onChange,
  pattern,
  inputMode,
  inputProps = {},
  InputProps,
  schema = {},
  ...rest
}) {
  const [isFocused, setIsFocused] = React.useState(false);
  const regex = pattern ? new RegExp(pattern) : null;
  const type = schema?.type;

  const handleChange = (e) => {
    let v = e.target.value;

    if (!regex || v === "" || regex.test(v)) {
      if (type === "integer") {
        v = parseInt(v, 10);
      } else if (type === "number") {
        v = parseFloat(v);
      }
      onChange(name, v);
    }
  };

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />
      {subTitle && subTitle !== "" && (
        <QuestionSubTitle label={subTitle} sx={sharedStyles.label(isFocused)} />
      )}

      <TextField
        {...rest}
        fullWidth
        inputMode={inputMode}
        inputProps={{ ...inputProps, pattern }}
        InputProps={InputProps}
        name={name}
        onBlur={() => setIsFocused(false)}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        size="small"
        sx={{
          ...sharedStyles.textField,
          ...(rest?.isTextarea && sharedStyles.textArea),
        }}
        multiline={rest?.isTextarea}
        value={value ?? ""}
        variant="outlined"
      />
      {footer && footer !== "" && (
        <QuestionFooter label={footer} sx={sharedStyles.label(isFocused)} />
      )}
    </Box>
  );
}
